<template>
    <div class="hotel-meal-type-label cursor-pointer d-flex align-center" @click="showInfo">
        <v-icon v-if="room.mealTypeOTACode !== 14" class="text-info" start size="small">
            mdi-silverware-fork-knife
        </v-icon>
        <v-icon v-else size="small" start class="text-info">mdi-information-outline</v-icon>
        <span class="text-caption">{{ label }}</span>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_MEAL_TYPE_INFO_EVENT} from '@/utils/event-bus'

    @Component
    export class HotelMealTypeLabel extends Vue {
        @Prop({required: true}) hotel
        @Prop({required: true}) room
        @Prop({default: () => []}) selectedMealTypes

        showInfo() {
            const mealTypeNames = !this.selectedMealTypes.length
                ? [this.room.mealTypeName]
                : this.selectedMealTypes.map(({mealTypeName}) => mealTypeName)
            EventBus.$emit(SHOW_MEAL_TYPE_INFO_EVENT, {hotel: this.hotel, mealTypeNames, room: this.room})
        }

        get label() {
            if (!this.selectedMealTypes.length) return this.room.mealTypeName
            return this.selectedMealTypes.map(({name, quantity}) => `${name} * ${quantity}`).join(', ')
        }
    }

    export default HotelMealTypeLabel
</script>
